import { z } from 'zod'
import { stringSchema } from './common'
import { storefrontViewSchema } from './storefront-view'

const tagSchema = z.object({
  id: stringSchema.min(1),
  name: stringSchema.min(1),
})

const pathAlternativeSchema = z.object({
  path: stringSchema.min(1),
  siteId: stringSchema.min(1),
})

export const pageSchema = z.object({
  id: stringSchema.min(1),
  hasChild: z.boolean().nullish(),
  parentId: stringSchema.nullish(),
  image: stringSchema.nullish(),
  media: z.array(z.any()).nullish(),
  path: stringSchema.min(1),
  pathAlternatives: z.array(pathAlternativeSchema),
  title: stringSchema.min(1),
  description: stringSchema.nullish(),
  body: stringSchema.nullish(),
  additionalDescription: stringSchema.nullish(),
  additionalNotes: stringSchema.nullish(),
  tags: z.array(tagSchema).nullish(),
  predefinedSearchCriteriaOptionId: z.string().nullish(),
  favourited: stringSchema.nullish(),
  seoTitle: stringSchema.nullish(),
  seoDescription: stringSchema.nullish(),
  seoKeywords: stringSchema.nullish(),
  templateAlias: stringSchema.min(1),
  content: z.any().nullish(),
  // Storefront views offered here (BOAT-1912); absent on list previews.
  views: z.array(storefrontViewSchema).default([]),
})
